import { useEffect, useState } from 'react';

import { CustomerType } from '../../../shared/constants/customer/customerType';
import { ScanMetadata } from '../../interfaces/scanMetadata';
import { getScanService } from '../../services/scanService/getScanService';

type UseScansMetadataParams = {
  customerType: CustomerType;
  customerId: number;
  entityId?: number;
  scansMetadata?: ScanMetadata[];
};

type UseScansMetadataReturn = {
  scansMetadata: ScanMetadata[];
  isLoading: boolean;
};

export const useScansMetadata = ({
  customerType,
  customerId,
  entityId,
  scansMetadata,
}: UseScansMetadataParams): UseScansMetadataReturn => {
  const shouldFetch = !scansMetadata;
  const service = getScanService(customerType);

  const [fetchedScansMetadata, setFetchedScansMetadata] = useState<ScanMetadata[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(shouldFetch);

  const getScansMetadata = async () => {
    try {
      setIsLoading(true);
      const scans = await service.getScanDates(customerId, entityId, {
        isRunGlobalSpinner: false,
      });

      setFetchedScansMetadata(scans);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (shouldFetch) {
      getScansMetadata();
    }
  }, [shouldFetch, customerType, customerId, entityId]);

  return {
    scansMetadata: scansMetadata ?? fetchedScansMetadata,
    isLoading: isLoading,
  };
};
